import Loader from "components/global/Loader";
import Tooltip from "components/Tooltip";
import React from "react";

interface Props {
  txt: string;
  disabled?: boolean;
  icon?: string;
  isWithText?: boolean;
  handleClick: () => void;
  handleIconClick?: () => void;
  mainIcon?: string;
  isLoad?: boolean;
  tooltip?: string;
}

const ActionBtn: React.FC<Props> = ({
  txt,
  disabled,
  handleClick,
  icon,
  handleIconClick,
  isWithText,
  mainIcon,
  isLoad,
  tooltip,
}) => {
  const buttonContent = (
    <button type="button" onClick={handleClick} disabled={disabled || isLoad}>
      {isLoad ? (
        <Loader size={8} />
      ) : isWithText ? (
        mainIcon ? (
          <>
            <img className="action-btn__main-icon" src={mainIcon} alt="" />
            <span>{txt}</span>
          </>
        ) : (
          txt
        )
      ) : mainIcon ? (
        <img src={mainIcon} style={{ width: "25px", height: "25px" }} alt="" />
      ) : (
        "+"
      )}
    </button>
  );

  return (
    <div
      className={`action-btn-wrapper ${
        icon && handleIconClick ? "with-icon" : ""
      } ${isWithText ? "" : "no-text"}`}
    >
      {icon && handleIconClick && (
        <button
          type="button"
          onClick={handleIconClick}
          disabled={disabled || isLoad}
        >
          <img src={icon} alt="" />
        </button>
      )}

      {tooltip ? (
        <Tooltip text={tooltip} position="top">
          {buttonContent}
        </Tooltip>
      ) : (
        buttonContent
      )}
    </div>
  );
};

export default ActionBtn;
